import { render, staticRenderFns } from "./modal-scrollable-body.vue?vue&type=template&id=6369aaec&scoped=true"
import script from "./modal-scrollable-body.vue?vue&type=script&setup=true&lang=ts"
export * from "./modal-scrollable-body.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./modal-scrollable-body.vue?vue&type=style&index=0&id=6369aaec&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6369aaec",
  null
  
)

export default component.exports